import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Box,
  Button,
  Fab,
  CardActions,
  Dialog,
  DialogTitle,
  Divider,
  Icon,
  IconButton,
  InputAdornment,
  Stack,
  Tab,
  Tabs,
  TextField,
  TextareaAutosize,
  Tooltip,
  Typography,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import {
  AirlineSeatLegroomReducedRounded,
  CheckCircle,
  // Cancel as CancelIcon,
  Error as ErrorIcon,
  Pending,
  VolumeOff,
  VolumeUp,
} from "@mui/icons-material";
import routes from "../basic/routes";
import { v4 as uuidv4 } from "uuid";
import { checkRoomExistAPI, createRoomAPI } from "../services/backend";
import { Fireworks } from "fireworks-js";

const RoomValidityIcon = ({ validState }) => {
  console.log("validState");
  console.log(validState);
  if (validState === 1) {
    return <CheckCircle />;
  } else if (validState === 0) {
    return <ErrorIcon />;
  } else {
    return <Pending />;
  }
};

const AppLandingPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [soundOnOff, setSoundOnOff] = useState(true);
  const [isJoinRoomDialog, setIsJoinRoomDialog] = useState(false);
  const [roomIdDict, setRoomIdDict] = useState({
    roomId: "",
    validState: -1,
  });
  const roomIdDictRef = useRef({
    roomId: "",
    validState: -1,
  });
  const [isRoomCreating, setIsRoomCreating] = useState(false);

  const fireworksRef = useRef(null);
  // MARK: https://fireworks.js.org/
  const fireworksConfigRef = useRef({
    intensity: 5,
    explosion: 2,
    // traceLength: 5,
    traceSpeed: 3,
    gravity: 1,
    particles: 100,
    brightness: {
      min: 80,
      max: 100,
    },
    sound: {
      enabled: soundOnOff,
      files: [
        "../sounds/explosion0.mp3",
        "../sounds/explosion1.mp3",
        "../sounds/explosion2.mp3",
      ],
      volume: {
        min: 50,
        max: 70,
      },
    },
  });

  const getRoute = (key) => {
    const a = routes.filter((_route) => {
      return _route.key === key;
    })[0];
    return a.routeNav;
  };

  const updateFireworskConfig = ({ newConfig }) => {
    fireworksConfigRef.current = {
      ...fireworksConfigRef.current,
      ...newConfig,
    };
    fireworksRef.current.updateOptions(fireworksConfigRef.current);
  };

  const handleBeforeUnload = (evt) => {
    // evt.preventDefault();
    fireworksRef.current.stop();
  };

  useEffect(() => {
    window.addEventListener("beforeunload", handleBeforeUnload);
    fireworksRef.current = new Fireworks(
      document.getElementById("fireworks-container"),
      fireworksConfigRef.current
    );
    fireworksRef.current.start();
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  useEffect(() => {
    console.log("location");
    console.log(location);
    if (location.pathname !== "/") {
      fireworksRef.current.stop();
      console.log("STOp");
    }
  }, [location]);

  useEffect(() => {
    setRoomIdDict({ ...roomIdDict, validState: -1 });
    const timer = setTimeout(() => {
      // console.log("API call triggered");
      if (roomIdDict.roomId.trim().length > 0) {
        roomIdDictRef.current = roomIdDict;
        checkRoomExistAPI({ roomId: roomIdDict.roomId }).then(({ data }) => {
          const isRoomExist = data?.is_exist ?? -1;
          if (roomIdDictRef.current.roomId === roomIdDict.roomId) {
            setRoomIdDict({ ...roomIdDict, validState: isRoomExist });
            console.log("isRoomExist");
            console.log(isRoomExist);
          }
        });
      }
    }, 1000);

    return () => {
      clearTimeout(timer);
    };
  }, [roomIdDict.roomId]);

  useEffect(() => {
    updateFireworskConfig({
      newConfig: {
        sound: {
          ...fireworksConfigRef.current.sound,
          enabled: soundOnOff,
        },
      },
    });
  }, [soundOnOff]);

  return (
    <>
      <Box>
        <Box
          sx={{
            position: "absolute",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            height: "100vh",
            // ml: -1,
            // mr: -1,
            backgroundImage: 'url("/background/home-page-background.jpg")',
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <Typography
            variant="h1"
            sx={{
              fontSize: "8rem", // Adjust the font size as per your requirement
              fontWeight: "bold",
              color: "red",
              textShadow:
                "2px 2px 0 #fff, -2px -2px 0 #fff, 2px -2px 0 #fff, -2px 2px 0 #fff", // Adjust the border style and color as per your preference
            }}
          >
            許願樹
          </Typography>
        </Box>
        <Tooltip
          title="點擊開啟聲音"
          sx={{ position: "absolute", top: 96, right: 32 }}
        >
          <Fab
            color="white"
            onClick={() => {
              setSoundOnOff(!soundOnOff);
            }}
          >
            {soundOnOff ? <VolumeUp /> : <VolumeOff />}
          </Fab>
        </Tooltip>
        <Box
          sx={{
            position: "absolute",
            display: "flex",
            width: "99%",
            justifyContent: "space-around",
            bottom: 128,
          }}
        >
          <LoadingButton
            variant="contained"
            size="large"
            sx={{
              fontSize: 36,
              borderRadius: "24px",
              boxShadow: 15,
              pl: 6,
              pr: 6,
            }}
            loading={isRoomCreating}
            onClick={() => {
              const newRoomId = uuidv4().substr(0, 6).toUpperCase();
              setIsRoomCreating(true);
              createRoomAPI({ roomId: newRoomId })
                .then(({ data }) => {
                  if (data?.is_create_successfully ?? false) {
                    fireworksRef.current.stop();
                    navigate(`${getRoute("wishing-tree-page")}/${newRoomId}`);
                  }
                })
                .finally(() => {
                  setIsRoomCreating(false);
                });
            }}
          >
            新建房間
          </LoadingButton>

          <Button
            variant="contained"
            size="large"
            color="primary"
            sx={{
              fontSize: 36,
              borderRadius: "24px",
              boxShadow: 15,
              pl: 6,
              pr: 6,
            }}
            onClick={() => setIsJoinRoomDialog(true)}
          >
            加入房間
          </Button>
        </Box>
      </Box>
      <Dialog
        open={isJoinRoomDialog}
        onClose={() => setIsJoinRoomDialog(false)}
        fullWidth
      >
        {
          <Box sx={{ m: 4 }}>
            <Box sx={{ width: "100%" }}>
              <DialogTitle sx={{ p: 1 }}>加入許願樹房間</DialogTitle>
              <Divider sx={{ mb: 2 }} />
              <TextField
                margin="normal"
                required
                fullWidth
                id="roomId"
                label="房間編號"
                name="room ID"
                // autoComplete="email"
                autoFocus
                value={roomIdDict.roomId}
                onChange={(evt) => {
                  setRoomIdDict({ ...roomIdDict, roomId: evt.target.value });
                }}
                error={roomIdDict.validState === 0}
                helperText={roomIdDict.validState === 0 ? "找不到房間" : ""}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <Icon edge="end">
                        <RoomValidityIcon validState={roomIdDict.validState} />
                      </Icon>
                    </InputAdornment>
                  ),
                }}
              />

              <Divider sx={{ mb: 2 }} />
              <CardActions
                sx={{ display: "flex", justifyContent: "space-between" }}
              >
                <Button
                  variant="outlined"
                  onClick={() => setIsJoinRoomDialog(false)}
                >
                  返回
                </Button>
                <Button
                  variant="outlined"
                  disabled={roomIdDict.validState !== 1}
                  onClick={() => {
                    fireworksRef.current.stop();
                    navigate(
                      `${getRoute("wishing-tree-page")}/${roomIdDict.roomId}`
                    );
                  }}
                >
                  觀看許願樹
                </Button>
                <Button
                  variant="outlined"
                  disabled={roomIdDict.validState !== 1}
                  onClick={() => {
                    fireworksRef.current.stop();
                    navigate(
                      `${getRoute("fai-chun-page")}/${roomIdDict.roomId}`
                    );
                  }}
                >
                  我要寫揮春
                </Button>
              </CardActions>
            </Box>
          </Box>
        }
      </Dialog>
      <Box
        id="fireworks-container"
        sx={{
          position: "absolute",
          width: "99%",
          height: "93%",
          pointerEvents: "none",
        }}
      ></Box>
    </>
  );
};

const f = () => {};

export { AppLandingPage, f };
